import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import Swal from "sweetalert2";
import { colors } from "../../colors.const";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export async function pendingChangesModal() {
  return Swal.fire({
    title: "Ungespeicherte Änderungen",
    text: "Sie haben ungespeicherte Änderungen. Möchten Sie diese verwerfen?",
    icon: "warning",
    showCancelButton: true,
    focusCancel: true,
    confirmButtonColor: colors.solid.warning,
    confirmButtonText: "Verwerfen",
    cancelButtonText: "Abbrechen",
  });
}

@Injectable({
  providedIn: "root",
})
export class PendingChangesGuard {
  async canDeactivate(component: ComponentCanDeactivate): Promise<boolean | Observable<boolean>> {
    if (component.canDeactivate()) {
      return true;
    }
    const confirm = await pendingChangesModal();
    return confirm.isConfirmed;
  }
}
